import React from "react";
import RpaPlanningCase from "./RpaPlanningCase";
import _ from "lodash";
import moment from "moment";

/** @typedef {import('../../../app/models/UserModel.js').UserItem } UserItem */
/** @typedef {import('../../../app/models/CloseDayModel.js').CloseDayItem } CloseDayItem */
/** @typedef {import('../controllers/RpaController.js').FilterObj } FilterObj */

/**
 * @typedef {object} RpaScheduleGridParams
 * @property {import('../services/RpaPlanningService.js').ModifiedRpaResourceItem} rpaResource
 * @property {import('../models/RpaScheduleGridModel.js').RpaScheduleGridItem} rpaScheduleGrid
 * @property {FilterObj} filter
 * @property {boolean} cellheightWithGridScheduleOption
 * @property {Array<CloseDayItem>} closeDays
 * @property {boolean} transportAndParkingOption
 * @property {boolean} showScheduleEndHourOption
 * @property {boolean} showAvailableReservationsOption
 * @property {boolean} showFirstReservationOnCaseOption
 * @property {boolean} showNbTotalPersonsOption
 * @property {string} view
 * @property {?UserItem} connectedUser
 * @property {string} lang
 * @property {string} source
 * @property {string} dayStr
 */

/**
 * @param {RpaScheduleGridParams} props
 */
export default function RpaScheduleGrid({ rpaResource, rpaScheduleGrid, filter, cellheightWithGridScheduleOption, closeDays, transportAndParkingOption, showScheduleEndHourOption, showAvailableReservationsOption, showFirstReservationOnCaseOption, showNbTotalPersonsOption, view, connectedUser, lang, source, dayStr }) {
  var cellHeight = "auto";

  if (cellheightWithGridScheduleOption && view === "back") {
    cellHeight = `${moment(rpaScheduleGrid.end_hour, "HH:mm").diff(moment(rpaScheduleGrid.start_hour, "HH:mm"), "minutes") * 1.8}px`;
  }

  var rpaReservations = _.chain(rpaScheduleGrid.rpa_reservations)
    .filter(reservation => {
      var reservationMomentDate = moment(reservation.date).format("DD/MM/YYYY");
      return reservation.rpaResourceId === rpaResource.id && moment(filter.dayDate).format("DD/MM/YYYY") === reservationMomentDate;
    })
    .orderBy("id")
    .value();

  return (
    <div>
      <div className="resaplan__activity__schedule" style={{ height: cellHeight }}>
        <RpaPlanningCase dayDate={moment(filter.dayDate)} rpaResource={rpaResource} rpaScheduleGrid={rpaScheduleGrid} transportAndParkingOption={transportAndParkingOption} rpaReservations={rpaReservations} showScheduleEndHourOption={showScheduleEndHourOption} showAvailableReservationsOption={showAvailableReservationsOption} showFirstReservationOnCaseOption={showFirstReservationOnCaseOption} showNbTotalPersonsOption={showNbTotalPersonsOption} view={view} connectedUser={connectedUser} closeDays={closeDays} lang={lang} source={source} dayStr={dayStr} />
      </div>
    </div>
  );
}
